// @Flow
import math from './mathWrapper';
import Constants from '../NumericValues/Constants';

/**
 * Creating wrappers that utilize Fractions for certain MathJS functions that don't support BigNumbers as input.
 * Using regular javascript Numbers causes the usual weird floating point behavior.
 */

export function gcd(numA, numB) {
  return math.number(math.gcd(math.fraction(numA), math.fraction(numB)));
}

export function lcm(numA, numB) {
  return math.number(math.lcm(math.fraction(numA), math.fraction(numB)));
}

/**
 * Wrap these for ease of use with Decimal operations rather than Number operations
 */
export function subtract(numA, numB) {
  return math.number(math.subtract(math.bignumber(numA), math.bignumber(numB)));
}

export function add(numA, numB) {
  return math.number(math.add(math.bignumber(numA), math.bignumber(numB)));
}

/*
 * Rounds a number to a prescribed number of significant digits
 * @param {Number} value - the value to round
 * @param {Number} decimals - the number of significant digits required
 * @returns {Number} The rounded number
 */
export function round(value, decimals) {
  return Number(`${Math.round(Number(`${value}e${decimals}`))}e-${decimals}`);
}

/**
 * Checks a number against our set maximum precision
 * @param {Number} value - The value to check
 * @returns {boolean} True if and only if value is different after being rounded to maximum precision
 */
export function exceedsMaximumPrecision(value) {
  return round(value, Constants.MAXIMUM_DECIMAL_PRECISION) !== value;
}

export default math;
